const DECIMAL_PRECISION = 3;

export const roundMoney = (amount: string | number): string =>
	Number.parseFloat(String(amount)).toFixed(DECIMAL_PRECISION);
